import styled from "styled-components";
import { NewIcon } from "@bca/ui-library";
import theme from "../../styles/theme";

export const StyledMenu = styled.div`
  background-color: ${theme.color.white};
  height: 100vh;
  display: flex;
  flex: auto;
  flex-direction: column;
  padding: 2.938rem 1.375rem;
`;

export const StyledMenuHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledSpace = styled.div`
  display: flex;
  flex: auto;
`;

export const StyledNewIcon = styled(NewIcon)`
  cursor: pointer;
  svg {
    fill: ${theme.color.ctaActionLink};
  }
`;

export const StyledTitle = styled.div`
  font-size: 1.125rem;
  font-weight: 700;
  margin-top: 2.188rem;
  margin-left: 0.5rem;
`;

export const StyledMobileLinkContainer = styled.div`
  display: flex;
  margin-top: 1.25rem;
`;

export const StyledMobileLink = styled.a`
  color: ${theme.color.ctaActionLink};
  display: flex;
  flex: auto;
  max-height: 1.375rem;
`;

export const StyledMobileSpace = styled.div`
  display: flex;
  flex: auto;
`;
